import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { ProductService } from 'src/app/services/product.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-whatsapp-image',
  templateUrl: './whatsapp-image.component.html',
  styleUrls: ['./whatsapp-image.component.scss']
})
export class WhatsappImageComponent implements OnInit, OnDestroy{

  url = '';
  sanitizedUrl = '';


  value: any;

  @Input() finalValue: any;
  @Input() fileSizeLimit: number = 5 * 1024 * 1024;
  @Input() allowedMimeType: string[] = ['image/jpeg', 'image/png'];

  @Output() sendValue = new EventEmitter();

  imageVisible: boolean = true;

  public serverPath = environment.commonImageApi + 'whatsapp/';
  text: string;

  constructor(private snackBar: MatSnackBar,
    private productService: ProductService, private router: Router) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit(): void {

    this.text = "Save"
    this.value= this.finalValue;
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['finalValue'] && changes['finalValue'].currentValue !== undefined) {
      this.value = changes['finalValue'].currentValue;
      // Force detection or refresh logic if needed
    }
  }


  logo() {
    this.imageVisible = false;
  }

  imageDelete: boolean;
  imagesToRemoved: any = [];


  deleteImage() {
    this.imageVisible = false;
    this.imageDelete = true;
    let smallImage = "/whatsapp/" + this.finalValue;
    this.imagesToRemoved.push(smallImage);

    this.productService.deleteImage(this.imagesToRemoved).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save"
          this.imageVisible = true;
          this.imageDelete = false;
          this.finalValue='';
          this.sendValue.emit(this.finalValue);
        }
        else {
          this.imageVisible = true;
          this.imageDelete = false;

          this.text = "Save"
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {
        this.imageVisible = true;
      });

  }



  getResult(event) {
    this.imageVisible = true;

    

    this.sendValue.emit(event);
  }

  cancelUpload() {
    this.imageVisible = true;
  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
